import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import hotelList from '../../utils/hotels';
import { setHotel } from './checkingSlice';
import usePageNavigation from '../../hooks/usePageNavigation';

function HotelsPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { navigateNextPage } = usePageNavigation();

  const handleHotelSelect = (hotel) => {
    dispatch(setHotel(hotel));
    navigateNextPage('Checking');
  };

  return (
    <div className="hotels__content text-center">
      <p className="mb-0 app-txt-granite pp-fw-figtree-regular">{t('TXT_TITLE_CHECK_IN')}</p>
      <p className="mt-2 app-fs-h3 app-lh-h3 app-fw-notosans-bold app-txt-granite">{t('TXT_WELCOME')}</p>
      <p className="mb-1 app-txt-gray">{t('TXT_SELECT_HOTEL')}</p>

      <div className="mt-2">
        {hotelList.map((item) => (
          <Row key={item.HotelId} className="mb-3 justify-content-md-center">
            <Col xs={12} md={4} lg={4} xl={3} className="text-md-end text-center">
              <Button
                variant=""
                className="border-0 p-0 w-100"
                onClick={() => handleHotelSelect(item.HotelId)}
              >
                <Card body className="border-0 app-bg-sand py-2">
                  <p className="mb-0 app-fs-h5 app-fw-notosans-bold app-txt-granite app-lh-h5">{item.HotelName}</p>
                  <p className="mb-0 app-fs-h6 text-uppercase app-txt-granite app-lh-h6">{item.HotelLocation}</p>
                </Card>
              </Button>
            </Col>
          </Row>
        ))}
      </div>
    </div>
  );
}

export default HotelsPage;
